import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home";
import Settings from "@/views/Settings";

// stop Navigation Duplicated errors from firing
// src: https://stackoverflow.com/a/58439497/827129
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name != "NavigationDuplicated") {
      throw err;
    }
  });
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
